module.exports = __webpack_public_path__ + "img/paper-plane.ec9ee5e6.png";